import React, { useContext } from "react";
// import { NotificationManager } from "react-notifications";
// import instance from "../../../../common/api/interceptor";
import FieldDate from "../../../../common/component/form/FieldDate";
import FieldText from "../../../../common/component/form/FieldText";
// import FieldTime from "../../../../common/component/form/FieldTime";
import ModalBox from "../../../../common/component/Modal/Index";
import useForm from "../../../../common/hooks/useForm";
// import { path } from "../../../../constants/apiPath";
import { StoreContext } from "../../../../store";
import moment from "moment";

function FilterModal({ setLoading, getSystemLogg }) {
  const FromDate = useForm();
  const ToDate = useForm();
  const OrderID = useForm();
  const Ativity = useForm();
  const Doneby = useForm();
  const Orgnisation = useForm();
  const context = useContext(StoreContext);
  const onApplyFilters = async () => {
    context.setLogData([]);
    const body = {
      OrderPK: "",
      FromDate: FromDate.value
        ? moment(FromDate.value).format("YYYY-MM-DD")
        : "",
      ToDate: ToDate.value ? moment(ToDate.value).format("YYYY-MM-DD") : "",
      OrderID: OrderID.value,
      Ativity: Ativity.value,
      Doneby: Doneby.value,
      Orgnisation: Orgnisation.value,
    };
    getSystemLogg(
      "",
      body.FromDate,
      body.ToDate,
      body.OrderID,
      body.Ativity,
      body.Doneby,
      body.Orgnisation,
      "Log_LastUpdatedDate",
      "ASC",
      0
    );
    context.setModalOpen(false);
  };
  const onClear = () => {
    context.setLogData([]);
    FromDate.setValue("");
    ToDate.setValue("");
    OrderID.setValue("");
    Ativity.setValue("");
    Doneby.setValue("");
    Orgnisation.setValue("");
    getSystemLogg("", "", "", "", "", "", "", "Log_LastUpdatedDate", "ASC", 0);
  };
  return (
    <ModalBox title="Filter By">
      <div className="_modalBody container-fluid">
        <div className="row ">
          <div className="col-md-6 col-12">
            <FieldDate
              label="Date From"
              value={FromDate.value}
              onChange={FromDate.onDateChange}
              error={FromDate.error}
              errorMsg={FromDate.errorMsg}
            />
          </div>
          <div className="col-md-6 col-12">
            <FieldDate
              label="Date To"
              value={ToDate.value}
              onChange={ToDate.onDateChange}
              error={ToDate.error}
              errorMsg={ToDate.errorMsg}
            />
          </div>
          {/* <div className="col-md-6 col-12">
            <FieldTime label="Time From" />
          </div>
          <div className="col-md-6 col-12">
            <FieldTime label="Time To" />
          </div> */}
          <div className="col-md-6 col-12">
            <FieldText
              label="Order ID"
              value={OrderID.value}
              onChange={OrderID.onChange}
              error={OrderID.error}
              errorMsg={OrderID.errorMsg}
            />
          </div>
          <div className="col-md-6 col-12">
            <FieldText
              label="Activity"
              value={Ativity.value}
              onChange={Ativity.onChange}
              error={Ativity.error}
              errorMsg={Ativity.errorMsg}
            />
          </div>
          <div className="col-md-6 col-12">
            <FieldText
              label="Done by"
              value={Doneby.value}
              onChange={Doneby.onChange}
              error={Doneby.error}
              errorMsg={Doneby.errorMsg}
            />
          </div>
          <div className="col-md-6 col-12">
            <FieldText
              label="Organisation"
              value={Orgnisation.value}
              onChange={Orgnisation.onChange}
              error={Orgnisation.error}
              errorMsg={Orgnisation.errorMsg}
            />
          </div>
          <div className="col-12">
            <div className="_modalFooter justify-content-between">
              <div className="_outlineButton">
                <button onClick={() => onClear()}>Clear Filter</button>
              </div>
              <div className="_solidButton">
                <button onClick={() => onApplyFilters()}>Apply</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalBox>
  );
}

export default FilterModal;
